<script setup>
  import HomeButton from '@/components/home/HomeButton.vue';

  import { HOME_CTA } from '@/constants/home';

  import homeownerPhoto from '@/assets/images/home/cta-homeowner.webp';

  defineEmits(['get-price']);
</script>

<template>
  <section class="bg-cobalt w-full">
    <div
      class="mx-auto flex w-full max-w-299 flex-col items-center px-5 pt-19 pb-25 md:px-8 md:pt-24 md:pb-28 lg:flex-row lg:justify-between lg:pt-14 lg:pb-28 xl:px-0"
    >
      <div
        v-reveal
        class="flex flex-col items-center text-center text-white lg:w-[46%] lg:items-start lg:text-left xl:w-[42%]"
      >
        <p
          class="text-[14px]/4 font-semibold tracking-[0.05em] uppercase md:text-[16px]/5 lg:text-[20px]/6"
        >
          {{ HOME_CTA.eyebrow }}
        </p>
        <h2
          class="mt-6 max-w-84 text-[34px]/10 font-bold text-balance whitespace-pre-line md:max-w-none md:text-[38px]/11 xl:text-[42px]/13"
        >
          {{ HOME_CTA.title }}
        </h2>
        <p
          class="mt-6 max-w-81 text-[14px]/5 font-medium md:max-w-120 md:text-[16px]/6 lg:mt-5 lg:max-w-116.5 lg:text-[18px]/6.5"
        >
          {{ HOME_CTA.description }}
        </p>
        <HomeButton variant="outline" class="mt-8 lg:mt-11" @click="$emit('get-price')">
          {{ HOME_CTA.cta }}
        </HomeButton>
      </div>

      <img
        v-reveal="150"
        :src="homeownerPhoto"
        :alt="HOME_CTA.imageAlt"
        width="600"
        height="600"
        loading="lazy"
        class="hidden h-auto lg:-mr-[1.7%] lg:block lg:w-[44.6%]"
      />
    </div>
  </section>
</template>
